import React from 'react';
import styled from 'styled-components';

import { Container, Typography, Link } from '@material-ui/core/';

import { companyContactDetails } from '../config.json';

import CardWrapper from '../components/common/CardWrapper';
import FormContact from '../components/forms/FormContact';
import IconAccount from '../assets/icon-account.svg';

const Root = styled.div`
	font-size: 16px;

	h1 {
		font-size: 24px;
		font-weight: bold;
	}

	h2 {
		margin-bottom: 20px;
		font-size: 18px;
		font-weight: bold;
	}

	a {
		color: ${(props) => props.theme.palette.text.link};
	}

	.contact__heading {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		img {
			margin-right: 20px;
			max-width: 50px;
			width: 100%;
			height: auto;
		}
	}
`;

const PageContact = () => (
	<Root>
		<Container maxWidth="lg">
			<CardWrapper>
				<div className="contact__heading">
					<img src={IconAccount} alt="Kontaktieren Sie uns!" />
					<Typography variant="h1">Sie möchten mehr wissen?</Typography>
				</div>
				<Typography variant="h2">Schreiben Sie uns!</Typography>
				<Typography>{companyContactDetails.phone}</Typography>
				<Link href={`mailto:${companyContactDetails.email}`}>
					{companyContactDetails.email}
				</Link>
				<FormContact />
			</CardWrapper>
		</Container>
	</Root>
);

export default PageContact;
